import { ref, nextTick, onBeforeUnmount } from 'vue';

export function useFloatingTooltip(options = {}) {
  const delay = options.delay ?? 500
  const margin = options.margin ?? 8

  let tooltipTimer
  const tooltip = ref({
    open: false,
    text: '',
    x: 0,
    y: 0,
    placement: 'right', // 'right' | 'left'
  })

  const tooltipElement = ref(null)

  async function openTooltip(anchorElement, text) {
    if (!anchorElement || typeof anchorElement.getBoundingClientRect !== 'function') return

    clearTimeout(tooltipTimer)

    tooltipTimer = setTimeout(async () => {
      const rect = anchorElement.getBoundingClientRect() // get anchor bounding box

      // Start on the right
      tooltip.value = {
        open: true,
        text,
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2,
        placement: 'right',
      }

      // If tooltip overflows right edge, flip to left
      await nextTick()

      const el = tooltipElement.value
      if (!el) return

      const tipRect = el.getBoundingClientRect() // get tooltip bounding box
      const vw = window.innerWidth // viewport width

      // Flip if it overflows the right edge
      if (tipRect.right > vw - margin) {
        tooltip.value = { ...tooltip.value, placement: 'left' }
      }
    }, delay)
  }

  function closeTooltip() {
    clearTimeout(tooltipTimer)
    tooltip.value.open = false
  }

  onBeforeUnmount(() => { clearTimeout(tooltipTimer) })

  return { tooltip, tooltipElement, openTooltip, closeTooltip }
}
